// extracted by mini-css-extract-plugin
export var labelWrapper = "_hi-0";